const initState = {
  court: null,
  courts: [],
  courtCount: 0,
  allCourts: [],
  courtsSlotsForWeek: [],
  courtDurations: [],
  slotsForBookingPageView: {
    data: [],
    totalRecords: 0,
  },
  slotsForBookingWindow: {
    data: [],
    totalRecords: 0,
  },
  bookCourtModal: false,
  slotsTypes: [],
  triggerDataAgain: {
    status: false,
    action: "",
  },
  bookingSlots: [],
  blockedSlotsForBookingPageView:[],
  courtBlockedSlotsForBookingPageView: [],
  coachingSummary:{}
};

const CourtReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_COURT_DATA":
      return {
        ...state,
        court: action.payload.data,
      };
    case "SET_BOOKINGS_COURT_DATA":
      return {
        ...state,
        bookingSlots: action.payload.data,
      };

    case "SET_SLOTS_TYPES_DATA":
      return {
        ...state,
        slotsTypes: action.payload.data,
      };

    case "SET_COURT_COUNT":
      return {
        ...state,
        courtCount: action.payload.data,
      };
    case "SET_COURTS_DATA":
      return {
        ...state,
        courts: action.payload.data,
      };
    case "SET_ALL_COURTS_DATA":
      return {
        ...state,
        allCourts: action.payload.data,
      };
    case "SET_COURTS_SLOTS_FOR_WEEK":
      return {
        ...state,
        courtsSlotsForWeek: action.payload.data,
      };
     case "SET_COURTS_COACHING_SUMMARY":{
      return {
        ...state,
        coachingSummary:action.payload.data
      }
     } 
    case "GET_DATA_AGAIN":
      return {
        ...state,
        triggerDataAgain: action.payload.data,
      };

    case "SET_COURT_DURATIONS":
      return {
        ...state,
        courtDurations: action.payload.data,
      };
    case "SET_COURTS_SLOTS_FOR_BOOKING_PAGE_VIEW":
      return {
        ...state,
        slotsForBookingPageView: action.payload.data,
      };
    case "SET_BLOCKED_SLOTS_FOR_BOOKING_PAGE_VIEW":
      return {
        ...state,
        blockedSlotsForBookingPageView: action.payload.data,
      };
    case "SET_COURT_BLOCKED_SLOTS_FOR_BOOKING_PAGE_VIEW":
      return {
        ...state,
        courtBlockedSlotsForBookingPageView: action.payload.data,
      };

    case "SET_COURTS_SLOTS_FOR_BOOKING_WINDOW":
      return {
        ...state,
        slotsForBookingWindow: action.payload.data,
      };
    case "TOGGLE_BOOK_COURT_MODAL":
      return {
        ...state,
        bookCourtModal: !state.bookCourtModal,
      };
    default:
      return { ...state };
  }
};

export default CourtReducer;
